export default {
    dashboard: "dashboard",
    dashboardStudent: "student-dashboard",
    classes: "classes",
    pack: "collection",
    plan: "private/set",
    tasks: "exercises",
    play: "private/play",
    publicPlay: "public/play",
    publicPlan: "public/set",
    share: "public/classroom",
    join: "classroom",
    signup: "signup",
    login: "login",
    account: "account",
    browse: "browse",
    signupProfile: "signup-profile",
    teacher: "teacher",
    moderation: "moderation",
    meta: "properties",
    contact: "contact",
    metaOpus: "composition",
    metaRhythm: "rhythm",
    metaPitch: "pitch",
    metaTeaching: "teaching",
    metaOther: "other",
    unsubscribe: "unsubscribe",
    privacy: "privacy",
    terms: "terms-of-usage",
    verify: "verify",
    passwordRecovery: "password-recovery",
    help: "help",
    helpRhythmName: "rhythm-syllable",
    helpListingProcess: "publishing-process",
    helpCovid: "distance-teaching",
    helpExperience: "experience",
    helpFilters: "filters",
    helpMeta: "properties",
    closedClassroom: "classroom/closed",
    battleOfTheHuns: "battle-of-the-huns",
    homework: "homework",
    homeworkResult: "homework-result",
    homeworkStudentResults: "homework-results",
    homeworkCompleted: "homework-completed",
    scores: "scores",
    christmasEdition: "christmas-tuning",
    memory: "memory",
    choirs: "groups",
    choir: "choir",
    choirHome: "for-choirs",
    editPiece: "edit",
    practice: "practice",
    pieces: "pieces",
    positions: "positions",
    members: "members", // kell ez?
    metaGeneral: "general",
    metaDetails: "details",
    metaAdditionalInformation: "addition-information",
    translate: "translate",
    aboutUs: "about-us",
    testModeration: "moderate-exercise",
    teachingSettings: "teaching-settings",
    experience: "experience",
    publishingPolicies: "publishing-policies",
    newsletter: "newsletter",
    students: "students",
    signupStudent: "signup-student",
    results: "results",
    choirPreRegistration: "pre-registration",
};
